import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

// Übersetzungen für alle Sprachen
const translations = {
  sq: { // Albanisch (Standard)
    // Navigation
    'nav.home': 'Kryesore',
    'nav.services': 'Shërbimet',
    'nav.partners': 'Partnerët',
    'nav.contact': 'Kontakti',
    
    // Hero Section
    'hero.title': 'Brillanz & Glanz',
    'hero.slogan': 'Jetë me Ekselencë',
    'hero.subtitle': 'Shërbime premium pastrimi për shtëpi, zyra, prona AirBNB, restaurante dhe hotele. Duke krijuar rend, pastërti dhe cilësi të përmirësuar jetese në zonën tuaj të jetës.',
    'hero.bookNow': 'Rezervo Tani',
    'hero.learnMore': 'Mëso Më Shumë',
    
    // Trust elements
    'trust.secure': 'I Besueshëm dhe i Sigurt',
    'trust.experienced': 'Ekip me Përvojë',
    'trust.fivestar': 'Shërbim 5-Yje',
    
    // Services
    'services.title': 'Shërbimet Tona',
    'services.subtitle': 'Zgjidhni llojin e shërbimit që ju duhet',
    'services.description': 'Zgjidhje profesionale pastrimi të përshtatura për nevojat tuaja. Nga residencial në komercial, ne ofrojmë shërbim të jashtëzakonshëm me produkte miqësore me mjedisin.',
    'services.house.title': 'Pastrimi i Shtëpisë',
    'services.house.description': 'Pastrimi i plotë i shtëpisë suaj me cilësi profesionale.',
    'services.apartment.title': 'Pastrimi i Apartamentit',
    'services.apartment.description': 'Shërbim i specializuar për apartamente dhe hapësira të vogla.',
    'services.office.title': 'Pastrimi i Zyrës',
    'services.office.description': 'Pastrimi profesional për zyra dhe hapësira biznesi.',
    'services.airbnb.title': 'Menaxhimi AirBNB',
    'services.airbnb.description': 'Pastrimi i shpejtë dhe cilësor për pronat AirBNB.',
    'services.hotel.title': 'Pastrimi i Hotelit',
    'services.hotel.description': 'Shërbime të specializuara për hotele dhe pensione.',
    'services.autodetailing.title': 'Auto Detailing',
    'services.autodetailing.description': 'Pastrimi dhe detailing profesional i automjeteve.',
    'services.facade.title': 'Pastrimi i Fasadës',
    'services.facade.description': 'Pastrimi profesional i fasadave të ndërtesave.',
    'services.park.title': 'Pastrimi i Parkut/Ndërtesës',
    'services.park.description': 'Mirëmbajtje dhe pastrimi i hapësirave të jashtme.',
    
    // Services with Albanian names
    'service.general.name': 'Pastrimi i Përgjithshëm i Shtëpisë',
    'service.general.desc': 'Shërbim i plotë pastrimi për shtëpi dhe apartamente',
    'service.apartment.name': 'Pastrimi i Përgjithshëm i Apartmentevë',
    'service.apartment.desc': 'Shërbim i plotë pastrimi për shtëpi dhe apartamente',
    'service.business.name': 'Pastrimi i Bizneseve dhe Zyrave',
    'service.business.desc': 'Pastrimi profesional për zyra dhe hapësira biznesi',
    'service.deep.name': 'Pastrimi i Thellë për Hotele',
    'service.deep.desc': 'Shërbim pastrimi i thellë për hotele dhe prona turistike',
    'service.airbnb.name': 'Menaxhimi i AirBNB dhe Shërbimet e Çelësave',
    'service.airbnb.desc': 'Shërbim i plotë ndërrimi i AirBNB me menaxhim çelësash',
    'service.facade.name': 'Pastrimi i Fasadave dhe Graffiti',
    'service.facade.desc': 'Profesionale pastrimi i fasadave dhe heqja e graffiti-ve',
    'service.building.name': 'Pastrimi i Mirëmbajtjes për Ndërtesa Shumëfamiljare',
    'service.building.desc': 'Shërbim profesional mirëmbajtjeje për ndërtesa të mëdha rezidenciale',
    'service.park.name': 'Pastrimi dhe Mirëmbajtja e Parqeve',
    'service.park.desc': 'Profesionale mirëmbajtje e parqeve dhe hapësirave të gjelbra',
    
    // Service features
    'feature.dusting': 'Fshirja e pluhurit',
    'feature.vacuum': 'Fshesa me korrent', 
    'feature.mopping': 'Larja e dyshemesë',
    'feature.bathroom': 'Pastrimi i banjës',
    'feature.kitchen': 'Pastrimi i kuzhinës',
    'feature.offices': 'Hapësirat e zyrave',
    'feature.meetings': 'Sallat e mbledhjeve',
    'feature.common': 'Hapësirat e përbashkëta',
    'feature.disinfection': 'Dezinfektimi',
    'feature.waste': 'Menaxhimi i mbeturinave',
    'feature.checkin': 'Koordinimi i check-in/out',
    'feature.keys': 'Dorëzimi i çelësave',
    'feature.inventory': 'Kontrolli i inventarit',
    'feature.cleaning': 'Pastrimi',
    'feature.maintenance': 'Mirëmbajtja',
    'feature.facades': 'Pastrimi i fasadave',
    'feature.graffiti': 'Heqja e graffiti-ve',
    'feature.pressure': 'Pastrimi me presion',
    'feature.restoration': 'Restaurimi i fasadave',
    'feature.protection': 'Mbrojtja dhe konservimi',
    'feature.corridors': 'Pastrimi i korridoreve',
    'feature.stairs': 'Mirëmbajtja e shkallëve',
    'feature.windows': 'Pastrimi i dritareve',
    'feature.commonareas': 'Zonët e përbashkëta',
    'feature.external': 'Pastrimi i jashtëm',
    'feature.grass': 'Kujdesi për barishtë',
    'feature.trees': 'Prerja e drunjve',
    'feature.parks': 'Pastrimi i parqeve',
    'feature.gardens': 'Mirëmbajtja e lulishteve',
    'feature.irrigation': 'Sistemi i ujitjes',
    
    // Buttons
    'button.selectService': 'Zgjidh Shërbimin',
    'button.requestQuote': 'Kërko Ofertë Falas',
    'button.whatsapp': 'WhatsApp',
    
    // CTA section
    'cta.notfound': 'Nuk po gjeni shërbimin që kërkoni?',
    'cta.contact': 'Na kontaktoni për një ofertë të personalizuar. Jemi këtu për t\'ju ndihmuar!',
    
    // Payouts Status
    'payouts.incomplete': 'Jo të Plotësuara',
    'payouts.enabled': 'Aktive',
    'payouts.disabled': 'Çaktivizuar',

    // Empty States
    'empty.availableJobs': 'Nuk ka punë të disponueshme',
    'empty.availableJobsDesc': 'Kur të ketë punë të reja që përputhen me specializimin tuaj, do të shfaqen këtu.',
    'empty.assignedJobs': 'Nuk ka punë të caktuara',
    'empty.assignedJobsDesc': 'Punët që ju keni pranuar do të shfaqen këtu.',
    'empty.notifications': 'Nuk ka njoftimet',
    'empty.payouts': 'Nuk ka pagesa',

    // Partner Dashboard Interface
    'dashboard.title': 'Partner Dashboard',
    'dashboard.loading': 'Duke ngarkuar...',
    'dashboard.error': 'Gabim në ngarkim',
    'dashboard.welcome': 'Mirë se erdhët, {name}!',
    'dashboard.backBtn': 'Kthehu',
    
    // Dashboard Tabs
    'dashboard.tabs.available': 'Punë të Disponueshme',
    'dashboard.tabs.assigned': 'Punët e Mia',
    'dashboard.tabs.notifications': 'Njoftimet',
    'dashboard.tabs.payouts': 'Pagesat',
    'dashboard.tabs.earnings': 'Fitimet',
    'dashboard.tabs.reviews': 'Vlerësimet',
    
    // Job Status
    'job.status.available': 'Disponueshme',
    'job.status.assigned': 'E Caktuar',
    'job.status.in_progress': 'Në Proces',
    'job.status.completed': 'Përfunduar',
    'job.status.cancelled': 'Anuluar',
    
    // Job Actions
    'job.accept': 'Pranoje',
    'job.decline': 'Refuzo',
    'job.start': 'Fillo Punën',
    'job.complete': 'Përfundo',
    'job.viewDetails': 'Detajet',
    
    // Job Information
    'job.type': 'Lloji i Punës',
    'job.date': 'Data',
    'job.time': 'Ora',
    'job.duration': 'Kohëzgjatja',
    'job.location': 'Vendndodhja',
    'job.payment': 'Pagesa',
    'job.customer': 'Klienti',
    
    // Statistics
    'stats.totalJobs': 'Punë Totale',
    'stats.completedJobs': 'Punë të Përfunduara',
    'stats.earnings': 'Fitimet',
    'stats.rating': 'Vlerësimi',
    'stats.thisMonth': 'Këtë Muaj',
    
    // Notifications
    'notifications.new': 'Njoftim i Ri',
    'notifications.read': 'E Lexuar',
    'notifications.markRead': 'Shëno si të Lexuar',
    'notifications.empty': 'Nuk ka njoftimet',
    
    // Payouts
    'payouts.pending': 'Në Pritje',
    'payouts.paid': 'Paguar',
    'payouts.amount': 'Shuma',
    'payouts.date': 'Data e Pagesës',
    'payouts.method': 'Metoda',
    'payouts.empty': 'Nuk ka pagesa',

    // Dashboard Description Keys
    'dashboard.availableJobsDesc': 'Zgjidhni punët që përshtaten me specializimin tuaj',
    'dashboard.assignedJobsDesc': 'Menaxhoni punët tuaja të caktuara',
    'dashboard.notificationsDesc': 'Shikoni njoftimet tuaja të fundit',
    'dashboard.payoutsDesc': 'Shikoni historikun e pagesave tuaja',
    'dashboard.earningsDesc': 'Shikoni statistikat e fitimeve tuaja',
    'dashboard.reviewsDesc': 'Shikoni vlerësimet nga klientët',
    
    // Additional Stats
    'stats.totalEarnings': 'Fitime Totale',

    // Booking Form
    'booking.badge': 'Rezervo Shërbimin Tuaj',
    'booking.selectMarket': 'Zgjidhni vendin/tregun',
    
    // Markets
    'market.kosovo': 'Kosovo/Shqipëria',
    'market.switzerland': 'Zvicra',
    'market.germany': 'Gjermania',
    'booking.subtitle': 'Zgjidhni shërbimin dhe plotësoni të dhënat tuaja për një rezervim të shpejtë dhe profesional.',
    'booking.backBtn': 'Kthehu tek Faqja Kryesore',
    'booking.selectService': 'Zgjidhni Shërbimin Tuaj',
    'booking.changeService': 'Ndrysho Shërbimin',
    'booking.fillData': 'Plotësoni të Dhënat Tuaja',
    'booking.selectServiceFirst': 'Ju lutemi zgjidhni një shërbim më sipër për të vazhduar me rezervimin.',
    'booking.fullName': 'Emri i Plotë',
    'booking.email': 'Adresa elektronike',
    'booking.phone': 'Telefoni',
    'booking.preferredTime': 'Ora e Preferuar',
    'booking.selectTime': 'Zgjidhni orën',
    'booking.address': 'Adresa',
    'booking.addressPlaceholder': 'Shkruani adresën e plotë të vendbanimit',
    'booking.preferredDate': 'Data e Preferuar',
    'booking.selectDate': 'Zgjidhni datën',
    'booking.specialRequirements': 'Kërkesat Speciale',
    'booking.specialRequirementsPlaceholder': 'Nëse keni ndonjë kërkesë speciale, na e tregoni këtu...',
    'booking.paymentMethod': 'Mënyra e Pagesës',
    'booking.selectPaymentMethod': 'Zgjidhni mënyrën e pagesës',
    'booking.cash': 'Pagesa në Para të Gatshme',
    'booking.card': 'Pagesa me Kartë',
    'booking.twint': 'TWINT',
    'booking.submitting': 'Duke Rezervuar...',
    'booking.bookNow': 'Rezervo Tani',
    'booking.error': 'Gabim',
    'booking.errorDesc': 'Ju lutemi plotësoni të gjitha fushat e kërkuara dhe zgjidhni një shërbim.',
    'booking.errorServer': 'Dështoi në krijimin e rezervimit. Ju lutemi provoni përsëri.',
    'booking.paymentError': 'Dështoi në krijimin e sesionit të pagesës. Ju lutemi provoni përsëri.',
    'booking.success': 'Rezervimi u Konfirmua!',
    'booking.successDesc': 'Rezervimi juaj është dërguar. Do t\'ju kontaktojmë së shpejti për të konfirmuar takimin.',
    
    // Duration
    'duration.hours': 'orë',

    // Partner Program Buttons
    'partner.program.discover': 'Zbulo Programin Partner',
    'partner.program.login': 'Kyçuni si Partner',

    // Partner Hero Interface
    'partner.hero.back': 'Kthehu në Shtëpi',
    'partner.hero.title': 'Bëhuni Partner i Brillanz & Glanz',
    'partner.hero.subtitle': 'Bashkohuni me ekipin tonë profesional dhe fitoni duke punuar në mënyrë fleksibile si pastrues profesional.',
    'partner.hero.howItWorks': 'Si Funksionon?',
    'partner.hero.step1.title': 'Regjistrohuni',
    'partner.hero.step1.desc': 'Plotësoni formularin e regjistrimit dhe na tregoni për ekspertizën tuaj.',
    'partner.hero.step2.title': 'Verifikimi',
    'partner.hero.step2.desc': 'Ekipi ynë do t\'ju kontaktojë për intervistë dhe verifikim të kualifikimeve.',
    'partner.hero.step3.title': 'Merrni Punë',
    'partner.hero.step3.desc': 'Pranoni punë përmes aplikacionit tonë sipas orarit tuaj të preferuar.',
    'partner.hero.step4.title': 'Fitoni Para',
    'partner.hero.step4.desc': 'Pagesa automatike pas përfundimit të çdo pune përmes Stripe.',
    'partner.hero.requirements': 'Kërkesa për Partner',
    'partner.hero.basicReq': 'Kërkesat Bazë',
    'partner.hero.req1': 'Moshë mbi 18 vjeç',
    'partner.hero.req2': 'Përvojë në pastrimin profesional (të preferuar)',
    'partner.hero.req3': 'Dokumenta të vlefshme identifikimi',
    'partner.hero.req4': 'Llogari bankare për pagesa',
    'partner.hero.req5': 'Telefon smart për aplikacionin',
    'partner.hero.benefits': 'Përfitime Shtesë',
    'partner.hero.benefit1': 'Transport i vetë (më shumë punë)',
    'partner.hero.benefit2': 'Pajisje pastrimi (bonus për punë)',
    'partner.hero.benefit3': 'Fleksibilitet në orare',
    'partner.hero.benefit4': 'Eksperiencë me produkte ekologjike',
    'partner.hero.benefit5': 'Gjuhë të huaja (Gjermane, Angleze)',
    'partner.hero.cta': 'Gati të Filloni?',
    'partner.hero.ctaDesc': 'Bashkohuni me ekipin tonë profesional dhe filloni të fitoni duke punuar në mënyrë fleksibile!',
    'partner.hero.joinBtn': 'Bëhu Partner Tani',
    'partner.hero.contact': 'Kontaktoni',
    'partner.hero.questions': 'Keni pyetje? Kontaktoni me ne në',
    'partner.hero.phoneInfo': 'Ose telefononi në',
    'partner.hero.moreInfo': 'për më shumë informacione',

    // Dashboard Additional Keys  
    'dashboard.lastUpdate': 'Përditësuar:',
    'dashboard.refresh': 'Rifresko',
    'dashboard.autoOn': 'Auto ON',
    'dashboard.autoOff': 'Auto OFF',
    'job.updateError': 'Nuk mund të përditësohej statusi.',
    'stats.newNotifications': 'Njoftimet e Reja',

    // Partner Login Interface
    'partner.login.title': 'Kyçuni si Partner',
    'partner.login.subtitle': 'Hyni në llogarinë tuaj të partnerit',
    'partner.login.method': 'Si doni të hyni?',
    'partner.login.email': 'Me Email',
    'partner.login.partnerId': 'Me Partner ID',
    'partner.login.emailLabel': 'Adresa Elektronike',
    'partner.login.emailPlaceholder': 'partneri@shembull.com',
    'partner.login.emailHelp': 'Vendosni email-in që përdorët gjatë regjistrimit',
    'partner.login.partnerIdLabel': 'Partner ID',
    'partner.login.partnerIdPlaceholder': 'Vendosni Partner ID-në tuaj',
    'partner.login.partnerIdHelp': 'Partner ID-në tuaj e gjeni në email-in e konfirmimit',
    'partner.login.submit': 'Kyçuni',
    'partner.login.submitting': 'Duke u kyçur...',
    'partner.login.back': 'Kthehu',
    'partner.login.helpTitle': 'Nuk mund të hyni?',
    'partner.login.helpId': 'Partner ID-në tuaj e gjeni në email-in e regjistrimit',
    'partner.login.helpContact': 'Nëse keni harruar të dhënat, kontaktoni në +41 76 766 94 30',
    'partner.login.helpRegister': 'Nëse nuk jeni partner ende, regjistrohuni si partner i ri',
    'partner.login.registerButton': 'Kthehu për të u regjistruar si Partner',
    'partner.login.error.email': 'Ju lutemi vendosni email-in tuaj.',
    'partner.login.error.partnerId': 'Ju lutemi vendosni ID-në tuaj të partnerit.',
    'partner.login.error.notFound': 'Partner nuk u gjet',
    'partner.login.error.emailNotFound': 'Nuk u gjet asnjë partner me këtë email. Ju lutemi regjistrohuni si partner i ri.',
    'partner.login.error.idNotFound': 'Nuk u gjet asnjë partner me këtë ID. Ju lutemi kontrolloni ID-në.',
    'partner.login.error.general': 'Ndodhi një gabim gjatë hyrjes. Ju lutemi provoni përsëri.',
    'partner.login.welcome': 'Mirë se erdhët!',
    'partner.login.welcomeMessage': 'Mirë se erdhët, {name}!',
    
    // Partner Registration Form
    'partner.register.title': 'Regjistrimi i Partnerit',
    'partner.register.subtitle': 'Plotësoni formularin për t\'u bërë partner i Brillanz & Glanz',
    'partner.register.firstName': 'Emri',
    'partner.register.lastName': 'Mbiemri',
    'partner.register.email': 'Adresa elektronike',
    'partner.register.phone': 'Telefoni',
    'partner.register.address': 'Adresa',
    'partner.register.experience': 'Përvojë',
    'partner.register.bankAccount': 'Llogari Bankare',
    'partner.register.terms': 'Pranoj kushtet dhe mbrojtjen e të dhënave',
    'partner.register.submit': 'DËRGO APLIKIMIN',
    'partner.register.back': 'Kthehu',
    'partner.register.success': 'Regjistrimi u krye me sukses!',
    'partner.register.error.validation': 'Ju lutemi plotësoni të gjitha fushat e detyrueshme.',
    'partner.register.error.terms': 'Ju lutemi pranoni kushtet.',
    'partner.register.error.emailExists': 'Kjo adresë email është në përdorim.',
    'partner.register.error.network': 'Problem në lidhje. Ju lutemi provoni përsëri.',

    // Dashboard Additional Keys
    'dashboard.lastUpdate': 'Përditësuar:',
    'dashboard.refresh': 'Rifresko',
    'dashboard.autoOn': 'Auto ON',
    'dashboard.autoOff': 'Auto OFF',
    'job.updateError': 'Nuk mund të përditësohej statusi.',
    'stats.newNotifications': 'Njoftimet e Reja',

    // Service Features
    'service.includes': 'Përfshihet në shërbim',
    
    // Call to Action
    'cta.alternative': 'Na kontaktoni direkt',
    'cta.description': 'Keni pyetje? Na kontaktoni përmes Email ose WhatsApp',
    
    // Market-specific
    'market.location': 'Kosova dhe Shqipëria',

    // Contact - Kosovo/Albania
    'contact.phone': '+41 76 766 94 30',
    'contact.email': 'thaqi.kujtim@gmx.net',
    'contact.address': 'Zvicër'
  },

  de: { // Deutsch (Standard German)
    // Navigation
    'nav.home': 'Startseite',
    'nav.services': 'Dienstleistungen',
    'nav.partners': 'Partner',
    'nav.contact': 'Kontakt',
    
    // Hero Section
    'hero.title': 'Brillanz & Glanz',
    'hero.slogan': 'Leben mit Exzellenz',
    'hero.subtitle': 'Premium Reinigungsdienstleistungen für Häuser, Büros, AirBNB-Immobilien, Restaurants und Hotels. Wir schaffen Ordnung, Sauberkeit und verbesserte Lebensqualität.',
    'hero.bookNow': 'Jetzt buchen',
    'hero.learnMore': 'Mehr erfahren',
    
    // Trust elements
    'trust.secure': 'Vertrauenswürdig und Sicher',
    'trust.experienced': 'Erfahrenes Team',
    'trust.fivestar': '5-Sterne Service',
    
    // Services
    'services.title': 'Unsere Dienstleistungen',
    'services.subtitle': 'Wählen Sie die Art der Dienstleistung, die Sie benötigen',
    
    // Services with German names
    'service.general.name': 'Allgemeine Hausreinigung',
    'service.general.desc': 'Vollständiger Reinigungsservice für Häuser und Wohnungen',
    'service.apartment.name': 'Allgemeine Wohnungsreinigung', 
    'service.apartment.desc': 'Vollständiger Reinigungsservice für Häuser und Wohnungen',
    'service.business.name': 'Geschäfts- und Büroreinigung',
    'service.business.desc': 'Professionelle Reinigung für Büros und Geschäftsräume',
    'service.deep.name': 'Tiefenreinigung für Hotels',
    'service.deep.desc': 'Tiefenreinigungsservice für Hotels und touristische Immobilien',
    'service.airbnb.name': 'AirBNB Management und Schlüsselservice',
    'service.airbnb.desc': 'Kompletter AirBNB-Wechselservice mit Schlüsselmanagement',
    'service.facade.name': 'Fassaden- und Graffiti-Reinigung',
    'service.facade.desc': 'Professionelle Fassadenreinigung und Graffiti-Entfernung',
    'service.building.name': 'Wartungsreinigung für Mehrfamilienhäuser',
    'service.building.desc': 'Professioneller Wartungsservice für große Wohngebäude',
    'service.park.name': 'Park- und Anlagenreinigung',
    'service.park.desc': 'Professionelle Wartung von Parks und Grünflächen',
    
    // Service features
    'feature.dusting': 'Staubwischen',
    'feature.vacuum': 'Staubsaugen',
    'feature.mopping': 'Bodenwischung',
    'feature.bathroom': 'Badreinigung',
    'feature.kitchen': 'Küchenreinigung',
    'feature.offices': 'Büroräume',
    'feature.meetings': 'Konferenzräume',
    'feature.common': 'Gemeinschaftsräume',
    'feature.disinfection': 'Desinfektion',
    'feature.waste': 'Abfallmanagement',
    'feature.checkin': 'Check-in/out Koordination',
    'feature.keys': 'Schlüsselübergabe',
    'feature.inventory': 'Inventarkontrolle',
    'feature.cleaning': 'Reinigung',
    'feature.maintenance': 'Wartung',
    'feature.facades': 'Fassadenreinigung',
    'feature.graffiti': 'Graffiti-Entfernung',
    'feature.pressure': 'Hochdruckreinigung',
    'feature.restoration': 'Fassadenrestaurierung',
    'feature.protection': 'Schutz und Konservierung',
    'feature.corridors': 'Flurreinigung',
    'feature.stairs': 'Treppenwartung',
    'feature.windows': 'Fensterreinigung',
    'feature.commonareas': 'Gemeinschaftsbereiche',
    'feature.external': 'Außenreinigung',
    'feature.grass': 'Rasenpflege',
    'feature.trees': 'Baumschnitt',
    'feature.parks': 'Parkreinigung',
    'feature.gardens': 'Gartenwartung',
    'feature.irrigation': 'Bewässerungssystem',
    
    // Buttons
    'button.selectService': 'Service Auswählen',
    'button.requestQuote': 'Kostenloses Angebot Anfordern',
    'button.whatsapp': 'WhatsApp',
    
    // Payouts Status
    'payouts.incomplete': 'Unvollständig',
    'payouts.enabled': 'Aktiviert',
    'payouts.disabled': 'Deaktiviert',

    // Empty States
    'empty.availableJobs': 'Keine verfügbaren Jobs',
    'empty.availableJobsDesc': 'Wenn neue Jobs verfügbar sind, die Ihrer Spezialisierung entsprechen, werden sie hier angezeigt.',
    'empty.assignedJobs': 'Keine zugewiesenen Jobs',
    'empty.assignedJobsDesc': 'Jobs, die Sie angenommen haben, werden hier angezeigt.',
    'empty.notifications': 'Keine Benachrichtigungen',
    'empty.payouts': 'Keine Auszahlungen',

    // Partner Dashboard Interface
    'dashboard.title': 'Partner Dashboard',
    'dashboard.loading': 'Laden...',
    'dashboard.error': 'Fehler beim Laden',
    'dashboard.welcome': 'Willkommen, {name}!',
    'dashboard.backBtn': 'Zurück',
    
    // Dashboard Tabs
    'dashboard.tabs.available': 'Verfügbare Jobs',
    'dashboard.tabs.assigned': 'Meine Jobs',
    'dashboard.tabs.notifications': 'Benachrichtigungen',
    'dashboard.tabs.payouts': 'Auszahlungen',
    'dashboard.tabs.earnings': 'Verdienste',
    'dashboard.tabs.reviews': 'Bewertungen',
    
    // Job Status
    'job.status.available': 'Verfügbar',
    'job.status.assigned': 'Zugewiesen',
    'job.status.in_progress': 'In Bearbeitung',
    'job.status.completed': 'Abgeschlossen',
    'job.status.cancelled': 'Abgebrochen',
    
    // Job Actions
    'job.accept': 'Annehmen',
    'job.decline': 'Ablehnen',
    'job.start': 'Job starten',
    'job.complete': 'Abschließen',
    'job.viewDetails': 'Details',
    
    // Job Information
    'job.type': 'Job-Typ',
    'job.date': 'Datum',
    'job.time': 'Zeit',
    'job.duration': 'Dauer',
    'job.location': 'Standort',
    'job.payment': 'Bezahlung',
    'job.customer': 'Kunde',
    
    // Statistics
    'stats.totalJobs': 'Jobs Gesamt',
    'stats.completedJobs': 'Abgeschlossene Jobs',
    'stats.earnings': 'Verdienste',
    'stats.rating': 'Bewertung',
    'stats.thisMonth': 'Diesen Monat',
    
    // Notifications
    'notifications.new': 'Neue Benachrichtigung',
    'notifications.read': 'Gelesen',
    'notifications.markRead': 'Als gelesen markieren',
    'notifications.empty': 'Keine Benachrichtigungen',
    
    // Payouts
    'payouts.pending': 'Ausstehend',
    'payouts.paid': 'Bezahlt',
    'payouts.amount': 'Betrag',
    'payouts.date': 'Auszahlungsdatum',
    'payouts.method': 'Methode',
    'payouts.empty': 'Keine Auszahlungen',

    // Partner Program Buttons
    'partner.program.discover': 'Partner Programm entdecken',
    'partner.program.login': 'Partner Anmeldung',

    // Partner Hero Interface
    'partner.hero.back': 'Zurück zur Startseite',
    'partner.hero.title': 'Werden Sie Partner von Brillanz & Glanz',
    'partner.hero.subtitle': 'Schließen Sie sich unserem professionellen Team an und verdienen Sie flexibel als professioneller Reiniger.',
    'partner.hero.howItWorks': 'Wie funktioniert es?',
    'partner.hero.step1.title': 'Registrieren',
    'partner.hero.step1.desc': 'Füllen Sie das Registrierungsformular aus und erzählen Sie uns von Ihrer Expertise.',
    'partner.hero.step2.title': 'Verifizierung',
    'partner.hero.step2.desc': 'Unser Team wird Sie für ein Interview und eine Qualifikationsüberprüfung kontaktieren.',
    'partner.hero.step3.title': 'Jobs erhalten',
    'partner.hero.step3.desc': 'Akzeptieren Sie Jobs über unsere App nach Ihrem bevorzugten Zeitplan.',
    'partner.hero.step4.title': 'Geld verdienen',
    'partner.hero.step4.desc': 'Automatische Zahlung nach Abschluss jeder Arbeit über Stripe.',
    'partner.hero.requirements': 'Partner-Anforderungen',
    'partner.hero.basicReq': 'Grundanforderungen',
    'partner.hero.req1': 'Alter über 18 Jahre',
    'partner.hero.req2': 'Erfahrung in der professionellen Reinigung (bevorzugt)',
    'partner.hero.req3': 'Gültige Ausweisdokumente',
    'partner.hero.req4': 'Bankkonto für Zahlungen',
    'partner.hero.req5': 'Smartphone für die App',
    'partner.hero.benefits': 'Zusätzliche Vorteile',
    'partner.hero.benefit1': 'Eigener Transport (mehr Jobs)',
    'partner.hero.benefit2': 'Reinigungsausrüstung (Bonus für Jobs)',
    'partner.hero.benefit3': 'Flexible Arbeitszeiten',
    'partner.hero.benefit4': 'Erfahrung mit umweltfreundlichen Produkten',
    'partner.hero.benefit5': 'Fremdsprachen (Deutsch, Englisch)',
    'partner.hero.cta': 'Bereit anzufangen?',
    'partner.hero.ctaDesc': 'Schließen Sie sich unserem professionellen Team an und beginnen Sie flexibel zu verdienen!',
    'partner.hero.joinBtn': 'Jetzt Partner werden',
    'partner.hero.contact': 'Kontakt',
    'partner.hero.questions': 'Haben Sie Fragen? Kontaktieren Sie uns unter',
    'partner.hero.phoneInfo': 'Oder rufen Sie an unter',
    'partner.hero.moreInfo': 'für weitere Informationen',

    // Partner Login Interface
    'partner.login.title': 'Partner Anmeldung',
    'partner.login.subtitle': 'Melden Sie sich in Ihr Partner-Konto an',
    'partner.login.method': 'Wie möchten Sie sich anmelden?',
    'partner.login.email': 'Mit E-Mail',
    'partner.login.partnerId': 'Mit Partner ID',
    'partner.login.emailLabel': 'E-Mail-Adresse',
    'partner.login.emailPlaceholder': 'partner@beispiel.com',
    'partner.login.emailHelp': 'Geben Sie die E-Mail ein, die Sie bei der Registrierung verwendet haben',
    'partner.login.partnerIdLabel': 'Partner ID',
    'partner.login.partnerIdPlaceholder': 'Geben Sie Ihre Partner ID ein',
    'partner.login.partnerIdHelp': 'Ihre Partner ID finden Sie in der Bestätigungs-E-Mail',
    'partner.login.submit': 'Anmelden',
    'partner.login.submitting': 'Anmeldung läuft...',
    'partner.login.back': 'Zurück',
    'partner.login.helpTitle': 'Können Sie sich nicht anmelden?',
    'partner.login.helpId': 'Ihre Partner ID finden Sie in der Registrierungs-E-Mail',
    'partner.login.helpContact': 'Bei vergessenen Daten kontaktieren Sie +41 76 766 94 30',
    'partner.login.helpRegister': 'Falls Sie noch kein Partner sind, registrieren Sie sich als neuer Partner',
    'partner.login.registerButton': 'Zurück zur Partner-Registrierung',
    'partner.login.error.email': 'Bitte geben Sie Ihre E-Mail ein.',
    'partner.login.error.partnerId': 'Bitte geben Sie Ihre Partner ID ein.',
    'partner.login.error.notFound': 'Partner nicht gefunden',
    'partner.login.error.emailNotFound': 'Kein Partner mit dieser E-Mail gefunden. Bitte registrieren Sie sich als neuer Partner.',
    'partner.login.error.idNotFound': 'Kein Partner mit dieser ID gefunden. Bitte überprüfen Sie die ID.',
    'partner.login.error.general': 'Ein Fehler ist beim Anmelden aufgetreten. Bitte versuchen Sie es erneut.',
    'partner.login.welcome': 'Willkommen!',
    'partner.login.welcomeMessage': 'Willkommen, {name}!',
    
    // Partner Registration Form
    'partner.register.title': 'Partner Registrierung',
    'partner.register.subtitle': 'Füllen Sie das Formular aus, um Partner von Brillanz & Glanz zu werden',
    'partner.register.firstName': 'Vorname',
    'partner.register.lastName': 'Nachname',
    'partner.register.email': 'E-Mail-Adresse',
    'partner.register.phone': 'Telefon',
    'partner.register.address': 'Adresse',
    'partner.register.experience': 'Erfahrung',
    'partner.register.bankAccount': 'Bankkonto',
    'partner.register.terms': 'Ich akzeptiere die Bedingungen und den Datenschutz',
    'partner.register.submit': 'BEWERBUNG SENDEN',
    'partner.register.back': 'Zurück',
    'partner.register.success': 'Registrierung erfolgreich abgeschlossen!',
    'partner.register.error.validation': 'Bitte füllen Sie alle Pflichtfelder aus.',
    'partner.register.error.terms': 'Bitte akzeptieren Sie die Bedingungen.',
    'partner.register.error.emailExists': 'Diese E-Mail-Adresse ist bereits registriert.',
    'partner.register.error.network': 'Verbindungsproblem. Bitte versuchen Sie es erneut.',

    // Dashboard Additional Keys
    'dashboard.lastUpdate': 'Aktualisiert:',
    'dashboard.refresh': 'Aktualisieren',
    'dashboard.autoOn': 'Auto EIN',
    'dashboard.autoOff': 'Auto AUS',
    'job.updateError': 'Status konnte nicht aktualisiert werden.',
    'stats.newNotifications': 'Neue Benachrichtigungen',

    // Booking Form
    'booking.badge': 'Buchen Sie Ihren Service',
    'booking.selectMarket': 'Wählen Sie Land/Markt',
    
    // Markets
    'market.kosovo': 'Kosovo/Albanien',
    'market.switzerland': 'Schweiz',
    'market.germany': 'Deutschland',
    'booking.subtitle': 'Wählen Sie den Service und geben Sie Ihre Daten für eine schnelle und professionelle Buchung ein.',
    'booking.backBtn': 'Zurück zur Startseite',
    'booking.selectService': 'Wählen Sie Ihren Service',
    'booking.changeService': 'Service ändern',
    'booking.fillData': 'Geben Sie Ihre Daten ein',
    'booking.selectServiceFirst': 'Bitte wählen Sie oben einen Service aus, um mit der Buchung fortzufahren.',
    'booking.fullName': 'Vollständiger Name',
    'booking.email': 'E-Mail-Adresse',
    'booking.phone': 'Telefon',
    'booking.preferredTime': 'Bevorzugte Zeit',
    'booking.selectTime': 'Zeit auswählen',
    'booking.address': 'Adresse',
    'booking.addressPlaceholder': 'Geben Sie die vollständige Adresse ein',
    'booking.preferredDate': 'Bevorzugtes Datum',
    'booking.selectDate': 'Datum auswählen',
    'booking.specialRequirements': 'Besondere Anforderungen',
    'booking.specialRequirementsPlaceholder': 'Wenn Sie besondere Anforderungen haben, teilen Sie uns diese hier mit...',
    'booking.paymentMethod': 'Zahlungsmethode',
    'booking.selectPaymentMethod': 'Zahlungsmethode auswählen',
    'booking.cash': 'Barzahlung',
    'booking.card': 'Kartenzahlung',
    'booking.twint': 'TWINT',
    'booking.submitting': 'Wird gebucht...',
    'booking.bookNow': 'Jetzt buchen',
    'booking.error': 'Fehler',
    'booking.errorDesc': 'Bitte füllen Sie alle erforderlichen Felder aus und wählen Sie einen Service.',
    'booking.errorServer': 'Buchung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'booking.paymentError': 'Zahlungssitzung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    'booking.success': 'Buchung bestätigt!',
    'booking.successDesc': 'Ihre Buchung wurde gesendet. Wir werden Sie bald kontaktieren, um den Termin zu bestätigen.',
    
    // Duration
    'duration.hours': 'Stunden',

    // Service Features
    'service.includes': 'Im Service enthalten',
    
    // Call to Action
    'cta.alternative': 'Kontaktieren Sie uns direkt',
    'cta.description': 'Haben Sie Fragen? Kontaktieren Sie uns über Email oder WhatsApp',
    
    // Market-specific
    'market.location': 'Deutschland',

    // CTA section
    'cta.notfound': 'Finden Sie nicht den gewünschten Service?',
    'cta.contact': 'Kontaktieren Sie uns für ein personalisiertes Angebot. Wir sind hier, um Ihnen zu helfen!',
    
    // Legal Pages
    'legal.backToHome': 'Zurück zur Startseite',
    'footer.description': 'Premium Reinigungsdienstleistungen für Häuser, Büros, AirBNB-Immobilien, Restaurants und Hotels.',
    'footer.quickLinks': 'Schnelllinks',
    'footer.privacy': 'Datenschutzerklärung',
    'footer.imprint': 'Impressum',
    'footer.contact': 'Kontakt',
    'footer.rights': 'Alle Rechte vorbehalten.',
    
    // Privacy
    'privacy.title': 'Datenschutzerklärung',
    'privacy.lastUpdated': 'Stand: Dezember 2025',
    'privacy.section1.title': '1. Allgemeine Hinweise',
    'privacy.section1.content': 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.',
    'privacy.section2.title': '2. Datenerfassung auf dieser Website',
    'privacy.section2.subtitle': 'Wer ist verantwortlich für die Datenerfassung?',
    'privacy.section2.content1': 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.',
    'privacy.section2.subtitle2': 'Wie erfassen wir Ihre Daten?',
    'privacy.section2.content2': 'Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen (z.B. durch Eingabe in ein Kontaktformular). Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst (z.B. Browsertyp, Betriebssystem).',
    'privacy.section3.title': '3. Welche Daten erheben wir?',
    'privacy.section3.item1': 'Name, E-Mail-Adresse, Telefonnummer (bei Buchungen)',
    'privacy.section3.item2': 'Adresse (für Dienstleistungen)',
    'privacy.section3.item3': 'IP-Adresse und Browserinformationen',
    'privacy.section3.item4': 'Datum und Uhrzeit des Zugriffs',
    'privacy.section4.title': '4. Wofür nutzen wir Ihre Daten?',
    'privacy.section4.content': 'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.',
    'privacy.section4.purpose1': 'Abwicklung von Buchungen und Zahlungen',
    'privacy.section4.purpose2': 'Kommunikation mit Kunden',
    'privacy.section4.purpose3': 'Verbesserung unserer Dienstleistungen',
    'privacy.section4.purpose4': 'Erfüllung gesetzlicher Verpflichtungen',
    'privacy.section5.title': '5. Zahlungsanbieter (Stripe)',
    'privacy.section5.content': 'Wir nutzen Stripe für die Zahlungsabwicklung. Bei Zahlungen über Stripe werden Ihre Zahlungsdaten direkt an Stripe übermittelt. Wir speichern keine vollständigen Kreditkartendaten. Weitere Informationen finden Sie in der Datenschutzerklärung von Stripe: https://stripe.com/privacy',
    'privacy.section6.title': '6. Ihre Rechte',
    'privacy.section6.intro': 'Sie haben jederzeit das Recht:',
    'privacy.section6.right1': 'Auskunft über Ihre gespeicherten Daten zu erhalten',
    'privacy.section6.right2': 'Berichtigung unrichtiger Daten zu verlangen',
    'privacy.section6.right3': 'Löschung Ihrer Daten zu verlangen',
    'privacy.section6.right4': 'Einschränkung der Datenverarbeitung zu verlangen',
    'privacy.section6.right5': 'Widerspruch gegen die Verarbeitung einzulegen',
    'privacy.section7.title': '7. Kontakt',
    'privacy.section7.content': 'Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an:',
    
    // Imprint
    'imprint.title': 'Impressum',
    'imprint.section1.title': 'Angaben gemäß Informationspflicht',
    'imprint.section2.title': 'Kontakt',
    'imprint.phone': 'Telefon',
    'imprint.section3.title': 'Vertretungsberechtigte Personen',
    'imprint.section3.representative': 'Geschäftsführer/Inhaber',
    'imprint.section4.title': 'Handelsregister',
    'imprint.registerCourt': 'Registergericht',
    'imprint.registerNumber': 'Registernummer',
    'imprint.section5.title': 'Umsatzsteuer-ID',
    'imprint.section5.content': 'Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz',
    'imprint.section6.title': 'Verantwortlich für den Inhalt',
    'imprint.section6.content': 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
    'imprint.section7.title': 'Online-Streitbeilegung',
    'imprint.section7.content': 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
    'imprint.section7.email': 'Unsere E-Mail-Adresse finden Sie oben im Impressum.',
    'imprint.section8.title': 'Haftungsausschluss',
    'imprint.section8.subtitle1': 'Haftung für Inhalte',
    'imprint.section8.content1': 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.',
    'imprint.section8.subtitle2': 'Haftung für Links',
    'imprint.section8.content2': 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.',
    
    // PWA
    'pwa.installTitle': 'App installieren',
    'pwa.installDescription': 'Fügen Sie Brillanz & Glanz zu Ihrem Home-Bildschirm hinzu für schnellen Zugriff und ein App-ähnliches Erlebnis.',
    'pwa.install': 'Installieren',
    'pwa.later': 'Später',
    
    // WhatsApp Messages
    'whatsapp.quoteMessage': 'Hallo! Ich interessiere mich für Ihre Reinigungsdienstleistungen und möchte ein kostenloses Angebot erhalten.',
    'whatsapp.contactMessage': 'Hallo! Ich möchte mehr über Ihre Reinigungsdienstleistungen erfahren.'
  },

  'de-ch': { // Schwizerdütsch
    // Navigation
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.partners': 'Partner',
    'nav.contact': 'Kontakt',
    
    // Hero Section
    'hero.title': 'Brillanz & Glanz',
    'hero.slogan': 'Läbe mit Exzellenz',
    'hero.subtitle': 'Premium Putz-Services für Hüüser, Büros, AirBNB-Immobilie, Restaurants und Hotels in dr ganze Schwiiz.',
    'hero.bookNow': 'Jetzt bueche',
    'hero.learnMore': 'Meh erfahre',
    
    // Trust elements
    'trust.secure': 'Vertrouenswürdig und sicher',
    'trust.experienced': 'Erfahrenes Team',
    'trust.fivestar': '5-Sterne Service',
    
    // Services
    'services.title': 'Üsi Services i dr Schwiiz',
    'services.subtitle': 'Wähl dr Service wo Du bruchsch',
    'services.description': 'Professionelli Putz-Lösige vo höchster Qualität für all Dini Bedürfniss. Vo Privathüüser bis zu gwerbliche Rüüm - mir bietete umwältfrundlichi und verlässlichi Services.',
    
    // Services with Schweizerdeutsch names
    'service.general.name': 'Putze vom Huus',
    'service.general.desc': 'Komplett Putze vom Huus mit professioneller Qualität',
    'service.apartment.name': 'Putze vo de Wohniig',
    'service.apartment.desc': 'Spezialisierti Services für Wohnige und chliini Rüüm',
    'service.business.name': 'Putze vom Büro',
    'service.business.desc': 'Professionells Putze vom Büro und Gschäftsrüüm',
    'service.deep.name': 'Tüüf Putz für Hotels',
    'service.deep.desc': 'Spezialisierti Services für Hotels und Pensione',
    'service.airbnb.name': 'AirBNB Verwautig und Schlüssel',
    'service.airbnb.desc': 'Schnells und hochwertig Putze für AirBNB-Immobilie',
    'service.facade.name': 'Putze vo de Fassade', 
    'service.facade.desc': 'Professionells Putze vo de Gebäude-Fassade',
    'service.building.name': 'Unterhalt vo Mehrfamiliehüüser',
    'service.building.desc': 'Professionelle Underhalts-Service für grossi Wohngebäude',
    'service.park.name': 'Putze vo de Pärk und Aalage',
    'service.park.desc': 'Professionelli Underhaltig vo de Parks und Grüefläche',
    
    // Service features in Schweizerdeutsch
    'feature.dusting': 'Staub wische',
    'feature.vacuum': 'Staubsuge',
    'feature.mopping': 'Bode putze',
    'feature.bathroom': 'Bad putze',
    'feature.kitchen': 'Chuchi putze',
    'feature.offices': 'Büro-Rüüm',
    'feature.meetings': 'Sitzigs-Rüüm',
    'feature.common': 'Gmeinschafts-Rüüm',
    'feature.disinfection': 'Desinfektion',
    'feature.waste': 'Abfall-Management',
    'feature.checkin': 'Check-in/out Koordination',
    'feature.keys': 'Schlüssel-Übergab',
    'feature.inventory': 'Inventar-Kontroll',
    'feature.cleaning': 'Putze',
    'feature.maintenance': 'Underhaltig',
    'feature.facades': 'Putze vo de Fassade',
    'feature.graffiti': 'Graffiti entferne',
    'feature.pressure': 'Hochdruck-Putze',
    'feature.restoration': 'Fassade-Restaurierig',
    'feature.protection': 'Schutz und Konservierig',
    'feature.corridors': 'Putze vo de Gäng',
    'feature.stairs': 'Treppe-Underhaltig',
    'feature.windows': 'Fänster putze',
    'feature.commonareas': 'Gmeinschafts-Bereich',
    'feature.external': 'Putze vo de Ussefläche',
    'feature.grass': 'Rase-Pfleg',
    'feature.trees': 'Baum-Schnitt',
    'feature.parks': 'Putze vo de Pärk',
    'feature.gardens': 'Garte-Underhaltig',
    'feature.irrigation': 'Bewässerigs-System',
    
    // Buttons
    'button.selectService': 'Service uswähle',
    'button.requestQuote': 'Gratis Offerte aafrage',
    'button.whatsapp': 'WhatsApp',
    
    // CTA section
    'cta.notfound': 'Findsch nöd dr gwünscht Service?',
    'cta.contact': 'Kontaktier üs für es personalisiertes Agebot. Mir sind da, für dir z\'hälfe!',
    
    // Partner Program - Schweiz
    'partner.hero.title': 'Wird Partner vo Brillanz & Glanz',
    'partner.hero.subtitle': 'Mach mit bi üsere Plattform und verdien bis zu CHF 5500/Monet als professionelle Mitarbeiter.',
    'partner.hero.joinNow': 'Jetzt Partner werde',
    'partner.hero.contact': 'Kontakt: +41 76 766 94 30',
    'partner.login.title': 'Als Partner aamelds',
    'partner.login.subtitle': 'Log di i Dis Partner-Konto ii',
    'partner.login.email': 'Mit Email',
    'partner.login.partnerId': 'Mit Partner ID',
    'partner.login.button': 'Aamelts',
    'partner.discover': 'Partner Programm entdecke',
    'partner.login': 'Als Partner aamelts',
    

    // Booking Form
    'booking.badge': 'Buech din Service',
    'booking.selectMarket': 'Wähl din Land/Markt',
    
    // Markets
    'market.kosovo': 'Kosovo/Albanie',
    'market.switzerland': 'Schwiiz',
    'market.germany': 'Dütschland',
    'booking.subtitle': 'Wähl de Service und gib dini Date ii für en schnelli und professionelli Buchig.',
    'booking.backBtn': 'Zrugg zur Startsyte',
    'booking.selectService': 'Wähl din Service',
    'booking.changeService': 'Service wächsle',
    'booking.fillData': 'Gib dini Date ii',
    'booking.selectServiceFirst': 'Bitte wähl obe en Service uus zum mit dr Buchig wytermache.',
    'booking.fullName': 'Vollständige Name',
    'booking.email': 'E-Mail Adrässe',
    'booking.phone': 'Telefon',
    'booking.preferredTime': 'Bevorzugti Zyt',
    'booking.selectTime': 'Zyt uswähle',
    'booking.address': 'Adrässe',
    'booking.addressPlaceholder': 'Gib di vollständigi Adrässe ii',
    'booking.preferredDate': 'Bevorzugts Datum',
    'booking.selectDate': 'Datum uswähle',
    'booking.specialRequirements': 'Spezielli Aforderige',
    'booking.specialRequirementsPlaceholder': 'Falls du spezielli Aforderige hesch, säg üs das hie...',
    'booking.paymentMethod': 'Zahligsart',
    'booking.selectPaymentMethod': 'Zahligsart uswähle',
    'booking.cash': 'Bar-Zahlig',
    'booking.card': 'Charte-Zahlig',
    'booking.twint': 'TWINT',
    'booking.submitting': 'Wird gbuecht...',
    'booking.bookNow': 'Jetzt bueche',
    'booking.error': 'Fähler',
    'booking.errorDesc': 'Bitte füll alli obligatorische Fälder uus und wähl en Service.',
    'booking.errorServer': 'Buchig het nöd klappt. Bitte versuechs nomal.',
    'booking.paymentError': 'Zahligssitzig het nöd chönne erstellt werde. Bitte versuechs nomal.',
    'booking.success': 'Buchig bestätigt!',
    'booking.successDesc': 'Dini Buchig isch gschickt worde. Mir werde di bald kontaktiere zum de Termin bestätige.',
    
    // Duration
    'duration.hours': 'Stundä',

    // Contact - Schweiz
    'contact.phone': '+41 76 766 94 30',
    'contact.email': 'thaqi.kujtim@gmx.net',
    'contact.address': 'Schwiiz',
    
    // Partner Dashboard Interface  
    'dashboard.title': 'Partner Dashboard',
    'dashboard.loading': 'Wird glade...',
    'dashboard.error': 'Fähler bim Lade',
    'dashboard.welcome': 'Willkomme, {name}!',
    'dashboard.backBtn': 'Zrugg',
    
    // Dashboard Additional Keys  
    'dashboard.lastUpdate': 'Letscht Update:',
    'dashboard.refresh': 'Aktualisiere',
    'dashboard.autoOn': 'Auto AA',
    'dashboard.autoOff': 'Auto UUS',
    'job.updateError': 'Status het nöd chöne aktualisiert werde.',
    'stats.newNotifications': 'Nöii Benachrichtigunge',

    // Dashboard Tabs
    'dashboard.tabs.available': 'Verfügbari Jobs',
    'dashboard.tabs.assigned': 'Mini Jobs',
    'dashboard.tabs.notifications': 'Benachrichtigunge',
    'dashboard.tabs.payouts': 'Uszahlige',
    'dashboard.tabs.earnings': 'Verdienst',
    'dashboard.tabs.reviews': 'Bewärtige',
    
    // Job Status
    'job.status.available': 'Verfügbar',
    'job.status.assigned': 'Zuegwise',
    'job.status.in_progress': 'I Bearbeitig',
    'job.status.completed': 'Abgschlosse',
    'job.status.cancelled': 'Abbroche',
    
    // Job Actions
    'job.accept': 'Aahne',
    'job.decline': 'Ablehne',
    'job.start': 'Job starte',
    'job.complete': 'Abschliesse',
    'job.viewDetails': 'Details',
    
    // Job Information
    'job.type': 'Job-Typ',
    'job.date': 'Datum',
    'job.time': 'Zyt',
    'job.duration': 'Duur',
    'job.location': 'Standort',
    'job.payment': 'Zahlig',
    'job.customer': 'Kund',
    
    // Statistics
    'stats.totalJobs': 'Jobs Total',
    'stats.completedJobs': 'Abgschloseni Jobs',
    'stats.earnings': 'Verdienst',
    'stats.rating': 'Bewärtig',
    'stats.thisMonth': 'Dä Monet',
    
    // Notifications
    'notifications.new': 'Nöii Benachrichtigung',
    'notifications.read': 'Gläse',
    'notifications.markRead': 'Als gläse markiere',
    'notifications.empty': 'Kei Benachrichtigunge',
    
    // Payouts
    'payouts.pending': 'Usstehend',
    'payouts.paid': 'Zahlt',
    'payouts.amount': 'Betrag',
    'payouts.date': 'Uszahligsdatum',
    'payouts.method': 'Methode',
    'payouts.empty': 'Kei Uszahlige',

    // Dashboard Description Keys  
    'dashboard.availableJobsDesc': 'Wähl Jobs uus wo zu dinere Spezialisierig passe',
    'dashboard.assignedJobsDesc': 'Verwalte dini zuegwiseni Jobs',
    'dashboard.notificationsDesc': 'Lueg dini letschte Benachrichtigunge aa',
    'dashboard.payoutsDesc': 'Lueg d Gschicht vo dine Uszahlige aa',
    'dashboard.earningsDesc': 'Lueg d Statistike vo dine Verdienst aa',
    'dashboard.reviewsDesc': 'Lueg d Bewärtige vo de Chunde aa',
    
    // Additional Stats  
    'stats.totalEarnings': 'Total Verdienst',

    // Partner Program Buttons  
    'partner.program.discover': 'Partner Programm entdecke',
    'partner.program.login': 'Partner Aamäldig',

    // Partner Hero Interface  
    'partner.hero.back': 'Zrugg zur Startsyte',
    'partner.hero.title': 'Werd Partner vo Brillanz & Glanz',
    'partner.hero.subtitle': 'Mach mit bi üsem professionelle Team und verdien flexibel als professionelle Putzer.',
    'partner.hero.howItWorks': 'Wies funktioniert?',
    'partner.hero.step1.title': 'Registrier di',
    'partner.hero.step1.desc': 'Füll s Registrierigs-Formular uus und verzell üs vo dinere Expertisä.',
    'partner.hero.step2.title': 'Verifikatione',
    'partner.hero.step2.desc': 'Üs Team wird di für es Interview und Qualifikatione-Prüefig kontaktiere.',
    'partner.hero.step3.title': 'Jobs übercho',
    'partner.hero.step3.desc': 'Akzeptier Jobs über üsi App nach dim bevorzugte Zytplan.',
    'partner.hero.step4.title': 'Gäld verdiene',
    'partner.hero.step4.desc': 'Automatischi Zahlig nach Abschluss vo jeder Arbet über Stripe.',
    'partner.hero.requirements': 'Partner-Aforderige',
    'partner.hero.basicReq': 'Grund-Aforderige',
    'partner.hero.req1': 'Alter über 18 Jahr',
    'partner.hero.req2': 'Erfahrig i dr professionelle Reinigiig (bevorzugt)',
    'partner.hero.req3': 'Gültigi Uswys-Dokumänt',
    'partner.hero.req4': 'Bankkonto für Zahlige',
    'partner.hero.req5': 'Smartphone für d App',
    'partner.hero.benefits': 'Zusätzlichi Vorteile',
    'partner.hero.benefit1': 'Eigene Transport (meh Jobs)',
    'partner.hero.benefit2': 'Reinigungs-Usrüstig (Bonus für Jobs)',
    'partner.hero.benefit3': 'Flexibli Arbetsyte',
    'partner.hero.benefit4': 'Erfahrig mit umwältfrundliche Prodükt',
    'partner.hero.benefit5': 'Frömdi Sprache (Dütsch, Englisch)',
    'partner.hero.cta': 'Bereit azfange?',
    'partner.hero.ctaDesc': 'Mach mit bi üsem professionelle Team und fang aa flexibel z verdiene!',
    'partner.hero.joinBtn': 'Jetzt Partner werde',
    'partner.hero.contact': 'Kontakt',
    'partner.hero.questions': 'Hesch Frage? Kontaktier üs unter',
    'partner.hero.phoneInfo': 'Oder rüef aa unter',
    'partner.hero.moreInfo': 'für wyteri Informatione',

    // Payouts Status  
    'payouts.incomplete': 'Nöd vollständig',
    'payouts.enabled': 'Aktiviert',
    'payouts.disabled': 'Deaktiviert',

    // Empty States  
    'empty.availableJobs': 'Kei verfügbari Jobs',
    'empty.availableJobsDesc': 'Wenn nöii Jobs verfügbar sind wo zu dinere Spezialisierig passe, werde si hie aazeigt.',
    'empty.assignedJobs': 'Kei zuegwiseni Jobs',
    'empty.assignedJobsDesc': 'Jobs wo du aagnoh hesch, werde hie aazeigt.',
    'empty.notifications': 'Kei Benachrichtigunge',
    'empty.payouts': 'Kei Uszahlige',

    // Partner Dashboard Interface  
    'dashboard.title': 'Partner Dashboard',
    'dashboard.loading': 'Wird glade...',
    'dashboard.error': 'Fähler bim Lade',
    'dashboard.welcome': 'Willkomme, {name}!',
    'dashboard.backBtn': 'Zrugg',
    
    // Dashboard Additional Keys  
    'dashboard.lastUpdate': 'Letscht Update:',
    'dashboard.refresh': 'Aktualisiere',
    'dashboard.autoOn': 'Auto AA',
    'dashboard.autoOff': 'Auto UUS',
    'job.updateError': 'Status het nöd chöne aktualisiert werde.',
    'stats.newNotifications': 'Nöii Benachrichtigunge',

    // Dashboard Tabs
    'dashboard.tabs.available': 'Verfügbari Jobs',
    'dashboard.tabs.assigned': 'Mini Jobs',
    'dashboard.tabs.notifications': 'Benachrichtigunge',
    'dashboard.tabs.payouts': 'Uszahlige',
    'dashboard.tabs.earnings': 'Verdienst',
    'dashboard.tabs.reviews': 'Bewärtige',
    
    // Job Status
    'job.status.available': 'Verfügbar',
    'job.status.assigned': 'Zuegwise',
    'job.status.in_progress': 'I Bearbeitig',
    'job.status.completed': 'Abgschlosse',
    'job.status.cancelled': 'Abbroche',
    
    // Job Actions
    'job.accept': 'Aahne',
    'job.decline': 'Ablehne',
    'job.start': 'Job starte',
    'job.complete': 'Abschliesse',
    'job.viewDetails': 'Details',
    
    // Job Information
    'job.type': 'Job-Typ',
    'job.date': 'Datum',
    'job.time': 'Zyt',
    'job.duration': 'Duur',
    'job.location': 'Standort',
    'job.payment': 'Zahlig',
    'job.customer': 'Kund',
    
    // Statistics
    'stats.totalJobs': 'Jobs Total',
    'stats.completedJobs': 'Abgschloseni Jobs',
    'stats.earnings': 'Verdienst',
    'stats.rating': 'Bewärtig',
    'stats.thisMonth': 'Dä Monet',
    
    // Notifications
    'notifications.new': 'Nöii Benachrichtigung',
    'notifications.read': 'Gläse',
    'notifications.markRead': 'Als gläse markiere',
    'notifications.empty': 'Kei Benachrichtigunge',
    
    // Payouts
    'payouts.pending': 'Usstehend',
    'payouts.paid': 'Zahlt',
    'payouts.amount': 'Betrag',
    'payouts.date': 'Uszahligsdatum',
    'payouts.method': 'Methode',
    'payouts.empty': 'Kei Uszahlige',

    // Partner Login Interface  
    'partner.login.title': 'Partner Aamäldig',
    'partner.login.subtitle': 'Mälds di i dis Partner-Konto aa',
    'partner.login.method': 'Wie wottsch di aamelts?',
    'partner.login.email': 'Mit E-Mail',
    'partner.login.partnerId': 'Mit Partner ID',
    'partner.login.emailLabel': 'E-Mail-Adräss',
    'partner.login.emailPlaceholder': 'partner@bispil.com',
    'partner.login.emailHelp': 'Gib d E-Mail ii wo du bi dr Registrierig brucht hesch',
    'partner.login.partnerIdLabel': 'Partner ID',
    'partner.login.partnerIdPlaceholder': 'Gib dini Partner ID ii',
    'partner.login.partnerIdHelp': 'Dini Partner ID findsch i dr Bestätigungs-E-Mail',
    'partner.login.submit': 'Aamelts',
    'partner.login.submitting': 'Aamäldig louft...',
    'partner.login.back': 'Zrugg',
    'partner.login.helpTitle': 'Chasch di nöd aamelts?',
    'partner.login.helpId': 'Dini Partner ID findsch i dr Registrierigs-E-Mail',
    'partner.login.helpContact': 'Bi vergässene Date kontaktier üs: +41 76 766 94 30',
    'partner.login.helpRegister': 'Falls du no kei Partner bisch, registrier di als neue Partner',
    'partner.login.registerButton': 'Zrugg zur Partner-Registrierig',
    'partner.login.error.email': 'Bitte gib dini E-Mail ii.',
    'partner.login.error.partnerId': 'Bitte gib dini Partner ID ii.',
    'partner.login.error.notFound': 'Partner nöd gfunde',
    'partner.login.error.emailNotFound': 'Kei Partner mit dere E-Mail gfunde. Bitte registrier di als neue Partner.',
    'partner.login.error.idNotFound': 'Kei Partner mit dere ID gfunde. Bitte prüef d ID.',
    'partner.login.error.general': 'Es isch en Fähler bim Aamelts passiert. Bitte probier es nomau.',
    'partner.login.welcome': 'Willkomme!',
    'partner.login.welcomeMessage': 'Willkomme, {name}!',
    
    // Partner Registration Form
    'partner.register.title': 'Partner Registrierig',
    'partner.register.subtitle': 'Füll s Formular uus zum Partner vo Brillanz & Glanz z werde',
    'partner.register.firstName': 'Vorname',
    'partner.register.lastName': 'Nachname',
    'partner.register.email': 'E-Mail-Adräss',
    'partner.register.phone': 'Telefon',
    'partner.register.address': 'Adräss',
    'partner.register.experience': 'Erfahrig',
    'partner.register.bankAccount': 'Bankkonto',
    'partner.register.terms': 'Ich akzeptier d Bedinggige und de Dateschutz',
    'partner.register.submit': 'BEWERBIG SCHICKE',
    'partner.register.back': 'Zrugg',
    'partner.register.success': 'Registrierig erfolgriich abgschlosse!',
    'partner.register.error.validation': 'Bitte füll alli Pflichtfälder uus.',
    'partner.register.error.terms': 'Bitte akzeptier d Bedinggige.',
    'partner.register.error.emailExists': 'Die E-Mail-Adräss isch scho registriert.',
    'partner.register.error.network': 'Verbindigsproblem. Bitte probier es nomau.',

    // Dashboard Additional Keys
    'dashboard.lastUpdate': 'Last Updated:',
    'dashboard.refresh': 'Refresh',
    'dashboard.autoOn': 'Auto ON',
    'dashboard.autoOff': 'Auto OFF',
    'job.updateError': 'Status could not be updated.',
    'stats.newNotifications': 'New Notifications',

    // Messages
    'msg.success': 'Erfolgrych!',
    'msg.error': 'Fähler!',
    'msg.loading': 'Wird glade...',
    'msg.welcome': 'Willkomme!',
    
    // Legal Pages (same as German, Swiss German variant)
    'legal.backToHome': 'Zrugg zur Startsyte',
    'footer.description': 'Premium Putz-Services für Hüüser, Büros, AirBNB-Immobilie, Restaurants und Hotels in dr ganze Schwiiz.',
    'footer.quickLinks': 'Schnälllinks',
    'footer.privacy': 'Dateschutzerklärig',
    'footer.imprint': 'Impressum',
    'footer.contact': 'Kontakt',
    'footer.rights': 'Alli Rächt vorbehalte.',
    'privacy.title': 'Dateschutzerklärig',
    'privacy.lastUpdated': 'Stand: Dezember 2025',
    'imprint.title': 'Impressum',
    
    // PWA
    'pwa.installTitle': 'App installiere',
    'pwa.installDescription': 'Füeg Brillanz & Glanz zu dim Home-Bildschirm hinzue für schnälle Zuegriff und es App-ähnlichs Erläbnis.',
    'pwa.install': 'Installiere',
    'pwa.later': 'Später',
    
    // WhatsApp Messages
    'whatsapp.quoteMessage': 'Hoi! Ich interessiere mich für eui Putz-Services und möcht es gratis Aagebot ha.',
    'whatsapp.contactMessage': 'Hoi! Ich möcht meh über eui Putz-Services erfahre.',
    
    // Duration
    'duration.hours': 'hours',

    // Messages
    'msg.success': 'Erfolgrych!',
    'msg.error': 'Fähler!',
    'msg.loading': 'Wird glade...',
    'msg.welcome': 'Willkomme!',
    
    // Service Features
    'service.includes': 'Im Service inbegriffen',
    
    // Call to Action
    'cta.alternative': 'Kontaktieret üs direkt',
    'cta.description': 'Heit dir Frage? Schribet üs über E-Mail oder WhatsApp',
    
    // Market-specific
    'market.currency': 'CHF',
    'market.pricing': 'swiss',
    'market.location': 'Schwiiz'
  },
  
  en: { // English
    // Navigation
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.partners': 'Partners',
    'nav.contact': 'Contact',
    
    // Hero Section
    'hero.title': 'Brillanz & Glanz',
    'hero.slogan': 'Living with Excellence',
    'hero.subtitle': 'Premium cleaning services for homes, offices, AirBNB properties, restaurants and hotels. Creating order, cleanliness and improved living quality in your area of Life.',
    'hero.bookNow': 'Book Now',
    'hero.learnMore': 'Learn More',
    
    // Trust elements
    'trust.secure': 'Trustworthy and Secure',
    'trust.experienced': 'Experienced Team',
    'trust.fivestar': '5-Star Service',
    
    // Services
    'services.title': 'Our Services',
    'services.subtitle': 'Choose the type of service you need',
    'services.description': 'Professional cleaning solutions tailored to your needs. From residential to commercial, we provide exceptional service with environmentally friendly products.',
    
    // Services with English names
    'service.general.name': 'General House Cleaning',
    'service.general.desc': 'Complete cleaning service for houses and apartments',
    'service.apartment.name': 'General Apartment Cleaning', 
    'service.apartment.desc': 'Complete cleaning service for houses and apartments',
    'service.business.name': 'Business and Office Cleaning',
    'service.business.desc': 'Professional cleaning for offices and business spaces',
    'service.deep.name': 'Deep Cleaning for Hotels',
    'service.deep.desc': 'Deep cleaning service for hotels and tourist properties',
    'service.airbnb.name': 'AirBNB Management and Key Services',
    'service.airbnb.desc': 'Complete AirBNB turnover service with key management',
    'service.facade.name': 'Facade and Graffiti Cleaning',
    'service.facade.desc': 'Professional facade cleaning and graffiti removal',
    'service.building.name': 'Maintenance Cleaning for Multi-Family Buildings',
    'service.building.desc': 'Professional maintenance service for large residential buildings',
    'service.park.name': 'Park and Facility Cleaning',
    'service.park.desc': 'Professional maintenance of parks and green spaces',
    
    // Service features in English
    'feature.dusting': 'Dusting',
    'feature.vacuum': 'Vacuuming',
    'feature.mopping': 'Floor mopping',
    'feature.bathroom': 'Bathroom cleaning',
    'feature.kitchen': 'Kitchen cleaning',
    'feature.offices': 'Office spaces',
    'feature.meetings': 'Meeting rooms',
    'feature.common': 'Common areas',
    'feature.disinfection': 'Disinfection',
    'feature.waste': 'Waste management',
    'feature.checkin': 'Check-in/out coordination',
    'feature.keys': 'Key handover',
    'feature.inventory': 'Inventory control',
    'feature.cleaning': 'Cleaning',
    'feature.maintenance': 'Maintenance',
    'feature.facades': 'Facade cleaning',
    'feature.graffiti': 'Graffiti removal',
    'feature.pressure': 'Pressure washing',
    'feature.restoration': 'Facade restoration',
    'feature.protection': 'Protection and conservation',
    'feature.corridors': 'Corridor cleaning',
    'feature.stairs': 'Stairs maintenance',
    'feature.windows': 'Window cleaning',
    'feature.commonareas': 'Common areas',
    'feature.external': 'External cleaning',
    'feature.grass': 'Lawn care',
    'feature.trees': 'Tree trimming',
    'feature.parks': 'Park cleaning',
    'feature.gardens': 'Garden maintenance',
    'feature.irrigation': 'Irrigation system',
    
    // Booking Form
    'booking.badge': 'Book Your Service',
    'booking.selectMarket': 'Select Country/Market',
    
    // Markets
    'market.kosovo': 'Kosovo/Albania',
    'market.switzerland': 'Switzerland',
    'market.germany': 'Germany',
    'booking.subtitle': 'Choose your service and fill in your details for a quick and professional booking.',
    'booking.backBtn': 'Back to Homepage',
    'booking.selectService': 'Choose Your Service',
    'booking.changeService': 'Change Service',
    'booking.fillData': 'Fill in Your Details',
    'booking.selectServiceFirst': 'Please select a service above to continue with booking.',
    'booking.fullName': 'Full Name',
    'booking.email': 'Email Address',
    'booking.phone': 'Phone',
    'booking.preferredTime': 'Preferred Time',
    'booking.selectTime': 'Select time',
    'booking.address': 'Address',
    'booking.addressPlaceholder': 'Enter your complete address',
    'booking.preferredDate': 'Preferred Date',
    'booking.selectDate': 'Select date',
    'booking.specialRequirements': 'Special Requirements',
    'booking.specialRequirementsPlaceholder': 'If you have any special requirements, please tell us here...',
    'booking.paymentMethod': 'Payment Method',
    'booking.selectPaymentMethod': 'Select payment method',
    'booking.cash': 'Cash Payment',
    'booking.card': 'Card Payment',
    'booking.twint': 'TWINT',
    'booking.submitting': 'Booking...',
    'booking.bookNow': 'Book Now',
    'booking.error': 'Error',
    'booking.errorDesc': 'Please fill in all required fields and select a service.',
    'booking.errorServer': 'Booking failed. Please try again.',
    'booking.paymentError': 'Failed to create payment session. Please try again.',
    'booking.success': 'Booking Confirmed!',
    'booking.successDesc': 'Your booking has been sent. We will contact you soon to confirm the appointment.',
    
    // Duration
    'duration.hours': 'hours',
    'feature.bathroom': 'Bathroom cleaning',
    'feature.kitchen': 'Kitchen cleaning',
    'feature.offices': 'Office spaces',
    'feature.meetings': 'Meeting rooms',
    'feature.common': 'Common areas',
    'feature.disinfection': 'Disinfection',
    'feature.waste': 'Waste management',
    'feature.checkin': 'Check-in/out coordination',
    'feature.keys': 'Key handover',
    'feature.inventory': 'Inventory control',
    'feature.cleaning': 'Cleaning',
    'feature.maintenance': 'Maintenance',
    'feature.facades': 'Facade cleaning',
    'feature.graffiti': 'Graffiti removal',
    'feature.pressure': 'Pressure washing',
    'feature.restoration': 'Facade restoration',
    'feature.protection': 'Protection and conservation',
    'feature.corridors': 'Corridor cleaning',
    'feature.stairs': 'Stairs maintenance',
    'feature.windows': 'Window cleaning',
    'feature.commonareas': 'Common areas',
    'feature.external': 'External cleaning',
    'feature.grass': 'Lawn care',
    'feature.trees': 'Tree trimming',
    'feature.parks': 'Park cleaning',
    'feature.gardens': 'Garden maintenance',
    'feature.irrigation': 'Irrigation system',
    
    // Partner Program - English
    'partner.hero.title': 'Become a Brillanz & Glanz Partner',
    'partner.hero.subtitle': 'Join our team and earn competitive rates as a professional collaborator.',
    'partner.hero.joinNow': 'Discover Partner Program',
    'partner.hero.contact': 'Contact: +41 76 766 94 30',
    'partner.login.title': 'Partner Login',
    'partner.login.subtitle': 'Sign in to your partner account',
    'partner.login.email': 'With Email',
    'partner.login.partnerId': 'With Partner ID',
    'partner.login.button': 'Sign In',
    'partner.discover': 'Discover Partner Program',
    'partner.loginBtn': 'Partner Login',
    
    // Forms
    'form.name': 'First Name',
    'form.lastName': 'Last Name',
    'form.email': 'Email Address',
    'form.phone': 'Phone',
    'form.address': 'Address',
    'form.date': 'Date',
    'form.time': 'Time',
    'form.specialRequirements': 'Special Requirements',
    'form.submit': 'Submit',
    'form.cancel': 'Cancel',
    'form.back': 'Back',
    'form.required': 'Required',
    
    // Buttons
    'btn.bookNow': 'Book Now',
    'btn.learnMore': 'Learn More',
    'btn.submit': 'Submit',
    'btn.cancel': 'Cancel',
    'btn.back': 'Back',
    'btn.next': 'Next',
    'btn.previous': 'Previous',
    'button.selectService': 'Select Service',
    'button.requestQuote': 'Request Free Quote',
    'button.whatsapp': 'WhatsApp',
    
    // CTA section
    'cta.notfound': 'Can\'t find the service you\'re looking for?',
    'cta.contact': 'Contact us for a personalized quote. We\'re here to help you!',
    
    // How We Work
    'howWeWork.title': 'How We Work',
    'howWeWork.subtitle': 'A structured process that guarantees high quality and complete customer satisfaction',
    'howWeWork.step1.title': 'Booking',
    'howWeWork.step2.title': 'Confirmation',
    'howWeWork.step3.title': 'Execution',
    'howWeWork.step4.title': 'Completion',
    'howWeWork.cta': 'Ready to Get Started?',
    
    // Payouts Status
    'payouts.incomplete': 'Incomplete',
    'payouts.enabled': 'Enabled',
    'payouts.disabled': 'Disabled',

    // Empty States
    'empty.availableJobs': 'No available jobs',
    'empty.availableJobsDesc': 'When new jobs that match your specialization are available, they will appear here.',
    'empty.assignedJobs': 'No assigned jobs',
    'empty.assignedJobsDesc': 'Jobs you have accepted will appear here.',
    'empty.notifications': 'No notifications',
    'empty.payouts': 'No payouts',

    // Partner Dashboard Interface
    'dashboard.title': 'Partner Dashboard',
    'dashboard.loading': 'Loading...',
    'dashboard.error': 'Error loading',
    'dashboard.welcome': 'Welcome, {name}!',
    'dashboard.backBtn': 'Back',
    
    // Dashboard Tabs
    'dashboard.tabs.available': 'Available Jobs',
    'dashboard.tabs.assigned': 'My Jobs',
    'dashboard.tabs.notifications': 'Notifications',
    'dashboard.tabs.payouts': 'Payouts',
    'dashboard.tabs.earnings': 'Earnings',
    'dashboard.tabs.reviews': 'Reviews',
    
    // Job Status
    'job.status.available': 'Available',
    'job.status.assigned': 'Assigned',
    'job.status.in_progress': 'In Progress',
    'job.status.completed': 'Completed',
    'job.status.cancelled': 'Cancelled',
    
    // Job Actions
    'job.accept': 'Accept',
    'job.decline': 'Decline',
    'job.start': 'Start Job',
    'job.complete': 'Complete',
    'job.viewDetails': 'Details',
    
    // Job Information
    'job.type': 'Job Type',
    'job.date': 'Date',
    'job.time': 'Time',
    'job.duration': 'Duration',
    'job.location': 'Location',
    'job.payment': 'Payment',
    'job.customer': 'Customer',
    
    // Statistics
    'stats.totalJobs': 'Total Jobs',
    'stats.completedJobs': 'Completed Jobs',
    'stats.earnings': 'Earnings',
    'stats.rating': 'Rating',
    'stats.thisMonth': 'This Month',
    
    // Notifications
    'notifications.new': 'New Notification',
    'notifications.read': 'Read',
    'notifications.markRead': 'Mark as Read',
    'notifications.empty': 'No notifications',
    
    // Payouts
    'payouts.pending': 'Pending',
    'payouts.paid': 'Paid',
    'payouts.amount': 'Amount',
    'payouts.date': 'Payout Date',
    'payouts.method': 'Method',
    'payouts.empty': 'No payouts',

    // Dashboard Description Keys
    'dashboard.availableJobsDesc': 'Choose jobs that match your specialization',
    'dashboard.assignedJobsDesc': 'Manage your assigned jobs',
    'dashboard.notificationsDesc': 'View your recent notifications',
    'dashboard.payoutsDesc': 'View your payment history',
    'dashboard.earningsDesc': 'View your earnings statistics',
    'dashboard.reviewsDesc': 'View reviews from customers',
    
    // Additional Stats
    'stats.totalEarnings': 'Total Earnings',

    // Partner Program Buttons
    'partner.program.discover': 'Discover Partner Program',
    'partner.program.login': 'Partner Login',

    // Partner Hero Interface
    'partner.hero.back': 'Back to Home',
    'partner.hero.title': 'Become a Brillanz & Glanz Partner',
    'partner.hero.subtitle': 'Join our professional team and earn working flexibly as a professional cleaner.',
    'partner.hero.howItWorks': 'How It Works?',
    'partner.hero.step1.title': 'Register',
    'partner.hero.step1.desc': 'Fill out the registration form and tell us about your expertise.',
    'partner.hero.step2.title': 'Verification',
    'partner.hero.step2.desc': 'Our team will contact you for an interview and qualification verification.',
    'partner.hero.step3.title': 'Get Jobs',
    'partner.hero.step3.desc': 'Accept jobs through our app according to your preferred schedule.',
    'partner.hero.step4.title': 'Earn Money',
    'partner.hero.step4.desc': 'Automatic payment after completion of each job through Stripe.',
    'partner.hero.requirements': 'Partner Requirements',
    'partner.hero.basicReq': 'Basic Requirements',
    'partner.hero.req1': 'Age over 18 years',
    'partner.hero.req2': 'Experience in professional cleaning (preferred)',
    'partner.hero.req3': 'Valid identity documents',
    'partner.hero.req4': 'Bank account for payments',
    'partner.hero.req5': 'Smartphone for the app',
    'partner.hero.benefits': 'Additional Benefits',
    'partner.hero.benefit1': 'Own transport (more jobs)',
    'partner.hero.benefit2': 'Cleaning equipment (bonus for jobs)',
    'partner.hero.benefit3': 'Flexible working hours',
    'partner.hero.benefit4': 'Experience with eco-friendly products',
    'partner.hero.benefit5': 'Foreign languages (German, English)',
    'partner.hero.cta': 'Ready to Start?',
    'partner.hero.ctaDesc': 'Join our professional team and start earning working flexibly!',
    'partner.hero.joinBtn': 'Become Partner Now',
    'partner.hero.contact': 'Contact',
    'partner.hero.questions': 'Have questions? Contact us at',
    'partner.hero.phoneInfo': 'Or call us at',
    'partner.hero.moreInfo': 'for more information',

    // Partner Login Interface
    'partner.login.title': 'Partner Login',
    'partner.login.subtitle': 'Sign in to your partner account',
    'partner.login.method': 'How would you like to sign in?',
    'partner.login.email': 'With Email',
    'partner.login.partnerId': 'With Partner ID',
    'partner.login.emailLabel': 'Email Address',
    'partner.login.emailPlaceholder': 'partner@example.com',
    'partner.login.emailHelp': 'Enter the email you used during registration',
    'partner.login.partnerIdLabel': 'Partner ID',
    'partner.login.partnerIdPlaceholder': 'Enter your Partner ID',
    'partner.login.partnerIdHelp': 'You can find your Partner ID in the confirmation email',
    'partner.login.submit': 'Sign In',
    'partner.login.submitting': 'Signing in...',
    'partner.login.back': 'Back',
    'partner.login.helpTitle': 'Can\'t sign in?',
    'partner.login.helpId': 'You can find your Partner ID in the registration email',
    'partner.login.helpContact': 'If you forgot your details, contact +41 76 766 94 30',
    'partner.login.helpRegister': 'If you\'re not a partner yet, register as a new partner',
    'partner.login.registerButton': 'Back to Partner Registration',
    'partner.login.error.email': 'Please enter your email.',
    'partner.login.error.partnerId': 'Please enter your Partner ID.',
    'partner.login.error.notFound': 'Partner not found',
    'partner.login.error.emailNotFound': 'No partner found with this email. Please register as a new partner.',
    'partner.login.error.idNotFound': 'No partner found with this ID. Please check the ID.',
    'partner.login.error.general': 'An error occurred while signing in. Please try again.',
    'partner.login.welcome': 'Welcome!',
    'partner.login.welcomeMessage': 'Welcome, {name}!',
    
    // Partner Registration Form
    'partner.register.title': 'Partner Registration',
    'partner.register.subtitle': 'Fill out the form to become a Brillanz & Glanz partner',
    'partner.register.firstName': 'First Name',
    'partner.register.lastName': 'Last Name',
    'partner.register.email': 'Email Address',
    'partner.register.phone': 'Phone',
    'partner.register.address': 'Address',
    'partner.register.experience': 'Experience',
    'partner.register.bankAccount': 'Bank Account',
    'partner.register.terms': 'I accept the terms and data protection',
    'partner.register.submit': 'SEND APPLICATION',
    'partner.register.back': 'Back',
    'partner.register.success': 'Registration completed successfully!',
    'partner.register.error.validation': 'Please fill in all required fields.',
    'partner.register.error.terms': 'Please accept the terms.',
    'partner.register.error.emailExists': 'This email address is already registered.',
    'partner.register.error.network': 'Connection problem. Please try again.',

    // Service Features
    'service.includes': 'Included in service',
    
    // Call to Action
    'cta.alternative': 'Contact us directly',
    'cta.description': 'Have questions? Contact us via Email or WhatsApp',
    
    // Market-specific
    'market.location': 'English Market',

    // Contact - International
    'contact.phone': '+41 76 766 94 30',
    'contact.email': 'thaqi.kujtim@gmx.net',
    'contact.address': 'Switzerland',
    
    // Legal Pages
    'legal.backToHome': 'Back to Home',
    'footer.description': 'Premium cleaning services for homes, offices, AirBNB properties, restaurants and hotels.',
    'footer.quickLinks': 'Quick Links',
    'footer.privacy': 'Privacy Policy',
    'footer.imprint': 'Imprint',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'privacy.title': 'Privacy Policy',
    'privacy.lastUpdated': 'Last updated: December 2025',
    'imprint.title': 'Imprint',
    
    // PWA
    'pwa.installTitle': 'Install App',
    'pwa.installDescription': 'Add Brillanz & Glanz to your home screen for quick access and an app-like experience.',
    'pwa.install': 'Install',
    'pwa.later': 'Later',
    
    // WhatsApp Messages
    'whatsapp.quoteMessage': 'Hello! I am interested in your cleaning services and would like to receive a free quote.',
    'whatsapp.contactMessage': 'Hello! I would like to learn more about your cleaning services.',
    
    // Messages
    'msg.success': 'Success!',
    'msg.error': 'Error!',
    'msg.loading': 'Loading...',
    'msg.welcome': 'Welcome!'
  },

  it: { // Italiano (Italian)
    // Navigation
    'nav.home': 'Home',
    'nav.services': 'Servizi',
    'nav.partners': 'Partner',
    'nav.contact': 'Contatto',
    
    // Hero Section
    'hero.title': 'Brillanz & Glanz',
    'hero.slogan': 'Vivere con Eccellenza',
    'hero.subtitle': 'Servizi di pulizia premium per case, uffici, proprietà AirBNB, ristoranti e hotel. Creiamo ordine, pulizia e qualità di vita migliorata.',
    'hero.bookNow': 'Prenota Ora',
    'hero.learnMore': 'Scopri di Più',
    
    // Trust elements
    'trust.secure': 'Affidabile e Sicuro',
    'trust.experienced': 'Team Esperto',
    'trust.fivestar': 'Servizio 5 Stelle',
    
    // Services
    'services.title': 'I Nostri Servizi',
    'services.subtitle': 'Scegli il tipo di servizio di cui hai bisogno',
    'services.description': 'Soluzioni di pulizia professionali su misura per le tue esigenze. Dal residenziale al commerciale, forniamo un servizio eccezionale con prodotti ecologici.',
    
    // Services with Italian names
    'service.general.name': 'Pulizia Generale della Casa',
    'service.general.desc': 'Servizio di pulizia completo per case e appartamenti',
    'service.apartment.name': 'Pulizia Generale Appartamento',
    'service.apartment.desc': 'Servizio di pulizia completo per case e appartamenti',
    'service.business.name': 'Pulizia Uffici e Aziende',
    'service.business.desc': 'Pulizia professionale per uffici e spazi commerciali',
    'service.deep.name': 'Pulizia Profonda per Hotel',
    'service.deep.desc': 'Servizio di pulizia profonda per hotel e proprietà turistiche',
    'service.airbnb.name': 'Gestione AirBNB e Servizio Chiavi',
    'service.airbnb.desc': 'Servizio completo di turnover AirBNB con gestione chiavi',
    'service.facade.name': 'Pulizia Facciate e Graffiti',
    'service.facade.desc': 'Pulizia professionale di facciate e rimozione graffiti',
    'service.building.name': 'Pulizia Manutenzione per Condomini',
    'service.building.desc': 'Servizio di manutenzione professionale per grandi edifici residenziali',
    'service.park.name': 'Pulizia e Manutenzione Parchi',
    'service.park.desc': 'Manutenzione professionale di parchi e aree verdi',
    
    // Service features
    'feature.dusting': 'Spolveratura',
    'feature.vacuum': 'Aspirapolvere',
    'feature.mopping': 'Lavaggio pavimenti',
    'feature.bathroom': 'Pulizia bagno',
    'feature.kitchen': 'Pulizia cucina',
    'feature.offices': 'Spazi uffici',
    'feature.meetings': 'Sale riunioni',
    'feature.common': 'Aree comuni',
    'feature.disinfection': 'Disinfezione',
    'feature.waste': 'Gestione rifiuti',
    'feature.checkin': 'Coordinamento check-in/out',
    'feature.keys': 'Consegna chiavi',
    'feature.inventory': 'Controllo inventario',
    'feature.cleaning': 'Pulizia',
    'feature.maintenance': 'Manutenzione',
    'feature.facades': 'Pulizia facciate',
    'feature.graffiti': 'Rimozione graffiti',
    'feature.pressure': 'Lavaggio ad alta pressione',
    'feature.restoration': 'Restauro facciate',
    'feature.protection': 'Protezione e conservazione',
    'feature.corridors': 'Pulizia corridoi',
    'feature.stairs': 'Manutenzione scale',
    'feature.windows': 'Pulizia finestre',
    'feature.commonareas': 'Aree comuni',
    'feature.external': 'Pulizia esterna',
    'feature.grass': 'Cura del prato',
    'feature.trees': 'Potatura alberi',
    'feature.parks': 'Pulizia parchi',
    'feature.gardens': 'Manutenzione giardini',
    'feature.irrigation': 'Sistema di irrigazione',
    
    // Buttons
    'button.selectService': 'Seleziona Servizio',
    'button.requestQuote': 'Richiedi Preventivo Gratuito',
    'button.whatsapp': 'WhatsApp',
    
    // CTA section
    'cta.notfound': 'Non trovi il servizio che cerchi?',
    'cta.contact': 'Contattaci per un preventivo personalizzato. Siamo qui per aiutarti!',
    
    // Booking Form
    'booking.badge': 'Prenota il Tuo Servizio',
    'booking.subtitle': 'Scegli il servizio e inserisci i tuoi dati per una prenotazione rapida e professionale.',
    'booking.backBtn': 'Torna alla Homepage',
    'booking.selectService': 'Scegli il Tuo Servizio',
    'booking.changeService': 'Cambia Servizio',
    'booking.fillData': 'Inserisci i Tuoi Dati',
    'booking.selectServiceFirst': 'Seleziona un servizio sopra per continuare con la prenotazione.',
    'booking.fullName': 'Nome Completo',
    'booking.email': 'Indirizzo Email',
    'booking.phone': 'Telefono',
    'booking.preferredTime': 'Orario Preferito',
    'booking.selectTime': 'Seleziona orario',
    'booking.address': 'Indirizzo',
    'booking.addressPlaceholder': 'Inserisci il tuo indirizzo completo',
    'booking.preferredDate': 'Data Preferita',
    'booking.selectDate': 'Seleziona data',
    'booking.specialRequirements': 'Richieste Speciali',
    'booking.specialRequirementsPlaceholder': 'Se hai richieste speciali, comunicacelo qui...',
    'booking.paymentMethod': 'Metodo di Pagamento',
    'booking.selectPaymentMethod': 'Seleziona metodo di pagamento',
    'booking.cash': 'Pagamento in Contanti',
    'booking.card': 'Pagamento con Carta',
    'booking.twint': 'TWINT',
    'booking.submitting': 'Prenotazione in corso...',
    'booking.bookNow': 'Prenota Ora',
    'booking.error': 'Errore',
    'booking.errorDesc': 'Compila tutti i campi obbligatori e seleziona un servizio.',
    'booking.errorServer': 'Prenotazione fallita. Riprova.',
    'booking.paymentError': 'Impossibile creare la sessione di pagamento. Riprova.',
    'booking.success': 'Prenotazione Confermata!',
    'booking.successDesc': 'La tua prenotazione è stata inviata. Ti contatteremo presto per confermare l\'appuntamento.',
    
    // Legal Pages
    'legal.backToHome': 'Torna alla Home',
    'footer.description': 'Servizi di pulizia premium per case, uffici, proprietà AirBNB, ristoranti e hotel.',
    'footer.quickLinks': 'Link Rapidi',
    'footer.privacy': 'Informativa sulla Privacy',
    'footer.imprint': 'Impressum',
    'footer.contact': 'Contatto',
    'footer.rights': 'Tutti i diritti riservati.',
    'privacy.title': 'Informativa sulla Privacy',
    'privacy.lastUpdated': 'Ultimo aggiornamento: Dicembre 2025',
    'imprint.title': 'Impressum',
    
    // PWA
    'pwa.installTitle': 'Installa App',
    'pwa.installDescription': 'Aggiungi Brillanz & Glanz alla tua schermata home per un accesso rapido e un\'esperienza simile a un\'app.',
    'pwa.install': 'Installa',
    'pwa.later': 'Più tardi',
    
    // WhatsApp Messages
    'whatsapp.quoteMessage': 'Ciao! Sono interessato ai vostri servizi di pulizia e vorrei ricevere un preventivo gratuito.',
    'whatsapp.contactMessage': 'Ciao! Vorrei saperne di più sui vostri servizi di pulizia.',
    
    // Duration
    'duration.hours': 'ore',
    
    // Service Features
    'service.includes': 'Incluso nel servizio',
    
    // Call to Action
    'cta.alternative': 'Contattaci direttamente',
    'cta.description': 'Hai domande? Contattaci tramite Email o WhatsApp',
    
    // Partner Program Buttons
    'partner.program.discover': 'Scopri il Programma Partner',
    'partner.program.login': 'Accedi come Partner',
    
    // Messages
    'msg.success': 'Successo!',
    'msg.error': 'Errore!',
    'msg.loading': 'Caricamento...',
    'msg.welcome': 'Benvenuto!'
  },

  fr: { // Français (French)
    // Navigation
    'nav.home': 'Accueil',
    'nav.services': 'Services',
    'nav.partners': 'Partenaires',
    'nav.contact': 'Contact',
    
    // Hero Section
    'hero.title': 'Brillanz & Glanz',
    'hero.slogan': 'Vivre avec Excellence',
    'hero.subtitle': 'Services de nettoyage premium pour maisons, bureaux, propriétés AirBNB, restaurants et hôtels. Créer l\'ordre, la propreté et une qualité de vie améliorée.',
    'hero.bookNow': 'Réserver Maintenant',
    'hero.learnMore': 'En Savoir Plus',
    
    // Trust elements
    'trust.secure': 'Fiable et Sécurisé',
    'trust.experienced': 'Équipe Expérimentée',
    'trust.fivestar': 'Service 5 Étoiles',
    
    // Services
    'services.title': 'Nos Services',
    'services.subtitle': 'Choisissez le type de service dont vous avez besoin',
    'services.description': 'Solutions de nettoyage professionnel adaptées à vos besoins. Du résidentiel au commercial, nous offrons un service exceptionnel avec des produits écologiques.',
    
    // Services with French names
    'service.general.name': 'Nettoyage Général de Maison',
    'service.general.desc': 'Service de nettoyage complet pour maisons et appartements',
    'service.apartment.name': 'Nettoyage Général d\'Appartement',
    'service.apartment.desc': 'Service de nettoyage complet pour maisons et appartements',
    'service.business.name': 'Nettoyage de Bureaux et Entreprises',
    'service.business.desc': 'Nettoyage professionnel pour bureaux et espaces commerciaux',
    'service.deep.name': 'Nettoyage en Profondeur pour Hôtels',
    'service.deep.desc': 'Service de nettoyage en profondeur pour hôtels et propriétés touristiques',
    'service.airbnb.name': 'Gestion AirBNB et Service de Clés',
    'service.airbnb.desc': 'Service complet de rotation AirBNB avec gestion des clés',
    'service.facade.name': 'Nettoyage de Façades et Graffitis',
    'service.facade.desc': 'Nettoyage professionnel de façades et enlèvement de graffitis',
    'service.building.name': 'Nettoyage d\'Entretien pour Immeubles',
    'service.building.desc': 'Service d\'entretien professionnel pour grands immeubles résidentiels',
    'service.park.name': 'Nettoyage et Entretien de Parcs',
    'service.park.desc': 'Entretien professionnel de parcs et espaces verts',
    
    // Service features
    'feature.dusting': 'Dépoussiérage',
    'feature.vacuum': 'Aspiration',
    'feature.mopping': 'Lavage des sols',
    'feature.bathroom': 'Nettoyage salle de bain',
    'feature.kitchen': 'Nettoyage cuisine',
    'feature.offices': 'Espaces de bureaux',
    'feature.meetings': 'Salles de réunion',
    'feature.common': 'Espaces communs',
    'feature.disinfection': 'Désinfection',
    'feature.waste': 'Gestion des déchets',
    'feature.checkin': 'Coordination check-in/out',
    'feature.keys': 'Remise des clés',
    'feature.inventory': 'Contrôle d\'inventaire',
    'feature.cleaning': 'Nettoyage',
    'feature.maintenance': 'Entretien',
    'feature.facades': 'Nettoyage de façades',
    'feature.graffiti': 'Enlèvement de graffitis',
    'feature.pressure': 'Nettoyage haute pression',
    'feature.restoration': 'Restauration de façades',
    'feature.protection': 'Protection et conservation',
    'feature.corridors': 'Nettoyage des couloirs',
    'feature.stairs': 'Entretien des escaliers',
    'feature.windows': 'Nettoyage des fenêtres',
    'feature.commonareas': 'Espaces communs',
    'feature.external': 'Nettoyage extérieur',
    'feature.grass': 'Entretien de pelouse',
    'feature.trees': 'Taille d\'arbres',
    'feature.parks': 'Nettoyage de parcs',
    'feature.gardens': 'Entretien de jardins',
    'feature.irrigation': 'Système d\'irrigation',
    
    // Buttons
    'button.selectService': 'Sélectionner le Service',
    'button.requestQuote': 'Demander un Devis Gratuit',
    'button.whatsapp': 'WhatsApp',
    
    // CTA section
    'cta.notfound': 'Vous ne trouvez pas le service que vous cherchez?',
    'cta.contact': 'Contactez-nous pour un devis personnalisé. Nous sommes là pour vous aider!',
    
    // Booking Form
    'booking.badge': 'Réservez Votre Service',
    'booking.subtitle': 'Choisissez le service et remplissez vos coordonnées pour une réservation rapide et professionnelle.',
    'booking.backBtn': 'Retour à l\'Accueil',
    'booking.selectService': 'Choisissez Votre Service',
    'booking.changeService': 'Changer le Service',
    'booking.fillData': 'Remplissez Vos Coordonnées',
    'booking.selectServiceFirst': 'Veuillez sélectionner un service ci-dessus pour continuer la réservation.',
    'booking.fullName': 'Nom Complet',
    'booking.email': 'Adresse Email',
    'booking.phone': 'Téléphone',
    'booking.preferredTime': 'Heure Préférée',
    'booking.selectTime': 'Sélectionner l\'heure',
    'booking.address': 'Adresse',
    'booking.addressPlaceholder': 'Entrez votre adresse complète',
    'booking.preferredDate': 'Date Préférée',
    'booking.selectDate': 'Sélectionner la date',
    'booking.specialRequirements': 'Demandes Spéciales',
    'booking.specialRequirementsPlaceholder': 'Si vous avez des demandes spéciales, dites-le nous ici...',
    'booking.paymentMethod': 'Méthode de Paiement',
    'booking.selectPaymentMethod': 'Sélectionner la méthode de paiement',
    'booking.cash': 'Paiement en Espèces',
    'booking.card': 'Paiement par Carte',
    'booking.twint': 'TWINT',
    'booking.submitting': 'Réservation en cours...',
    'booking.bookNow': 'Réserver Maintenant',
    'booking.error': 'Erreur',
    'booking.errorDesc': 'Veuillez remplir tous les champs obligatoires et sélectionner un service.',
    'booking.errorServer': 'La réservation a échoué. Veuillez réessayer.',
    'booking.paymentError': 'Impossible de créer la session de paiement. Veuillez réessayer.',
    'booking.success': 'Réservation Confirmée!',
    'booking.successDesc': 'Votre réservation a été envoyée. Nous vous contacterons bientôt pour confirmer le rendez-vous.',
    
    // Legal Pages
    'legal.backToHome': 'Retour à l\'Accueil',
    'footer.description': 'Services de nettoyage premium pour maisons, bureaux, propriétés AirBNB, restaurants et hôtels.',
    'footer.quickLinks': 'Liens Rapides',
    'footer.privacy': 'Politique de Confidentialité',
    'footer.imprint': 'Mentions Légales',
    'footer.contact': 'Contact',
    'footer.rights': 'Tous droits réservés.',
    'privacy.title': 'Politique de Confidentialité',
    'privacy.lastUpdated': 'Dernière mise à jour: Décembre 2025',
    'imprint.title': 'Mentions Légales',
    
    // PWA
    'pwa.installTitle': 'Installer l\'App',
    'pwa.installDescription': 'Ajoutez Brillanz & Glanz à votre écran d\'accueil pour un accès rapide et une expérience d\'application.',
    'pwa.install': 'Installer',
    'pwa.later': 'Plus tard',
    
    // WhatsApp Messages
    'whatsapp.quoteMessage': 'Bonjour! Je suis intéressé par vos services de nettoyage et j\'aimerais recevoir un devis gratuit.',
    'whatsapp.contactMessage': 'Bonjour! J\'aimerais en savoir plus sur vos services de nettoyage.',
    
    // Duration
    'duration.hours': 'heures',
    
    // Service Features
    'service.includes': 'Inclus dans le service',
    
    // Call to Action
    'cta.alternative': 'Contactez-nous directement',
    'cta.description': 'Vous avez des questions? Contactez-nous par Email ou WhatsApp',
    
    // Partner Program Buttons
    'partner.program.discover': 'Découvrir le Programme Partenaire',
    'partner.program.login': 'Connexion Partenaire',
    
    // Messages
    'msg.success': 'Succès!',
    'msg.error': 'Erreur!',
    'msg.loading': 'Chargement...',
    'msg.welcome': 'Bienvenue!'
  }
};

export const LanguageProvider = ({ children }) => {
  // Initialize language from localStorage or default to German
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('brillanz-glanz-language');
    // Default to German ('de') instead of Albanian
    return savedLanguage || 'de';
  });

  // Change language function with smooth React state update (no page reload)
  const changeLanguage = useCallback((newLanguage) => {
    console.log('🔄 changeLanguage called with:', newLanguage);
    setLanguage((currentLanguage) => {
      if (newLanguage !== currentLanguage) {
        // Save to localStorage for persistence
        localStorage.setItem('brillanz-glanz-language', newLanguage);
        console.log('✅ Language changed to:', newLanguage, '(no page reload)');
        return newLanguage;
      }
      return currentLanguage;
    });
  }, []);

  // Translation function - memoized with current language as dependency
  const t = useCallback((key, fallback = key) => {
    const translation = translations[language]?.[key];
    return translation || fallback;
  }, [language]);

  // Available languages (constant, defined outside would be better but keeping here for consistency)
  const availableLanguages = useMemo(() => ({
    de: 'Deutsch',
    'de-ch': 'Schwiizerdütsch',
    en: 'English',
    it: 'Italiano',
    fr: 'Français'
  }), []);

  // Memoize context value to prevent unnecessary re-renders of consumers
  const contextValue = useMemo(() => ({
    language,
    setLanguage: changeLanguage,
    t,
    availableLanguages
  }), [language]);

  // Debug effect
  useEffect(() => {
    console.log('LanguageProvider render - current language:', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};